import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import About from './pages/About';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import Footer from './components/Footer';
import Gallery from './pages/Gallery';
import Header from './components/Header';
import Home from './pages/Home';
import React from 'react';
import Team from './pages/Team';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/team" element={<Team />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
